import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, CircularProgress } from '@mui/material';
import { Header } from '../components/Header';
import { ActualYearCalendar } from '../components/CustomCalendar';
import { useTranslation } from 'react-i18next';
import useUserStore from '../store/UserStore';
import { STPButton } from '../components/Botones';
import { getCalendar } from '../services/getCalendar';
import { saveUserAction } from '../services/saveUserAction';
import axios from 'axios';

export function Calendario({ setIsAuthenticated }) {
  const { t } = useTranslation();
  const user = useUserStore(state => state.user);
  const [loading, setLoading] = useState(false);
  const [activeTiposFecha, setActiveTiposFecha] = useState([
    { nombre: 'clase', color: '#50A579', text: t('calendar.class') }
  ]);

  useEffect(() => {
    const fetchTiposFecha = async () => {
      try {
        // Obtener los tipos de fecha directamente de la base de datos
        const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}tipos-fecha`);
        
        // Mapear los tipos para incluir la traducción
        const mappedTypes = response.data.map(tipo => ({
          nombre: tipo.nombre,
          color: tipo.color,
          text: tipo.nombre
        }));
        
        // Asegurar que 'clase' esté siempre en la leyenda
        if (!mappedTypes.find(t => t.nombre === 'clase')) {
          mappedTypes.push({ nombre: 'clase', color: '#50A579', text: t('calendar.class') });
        }
        
        setActiveTiposFecha(mappedTypes);
      } catch (error) {
        console.error('Error al obtener tipos de fecha:', error);
        // Mantener al menos el tipo "clase" en caso de error
        setActiveTiposFecha([{ nombre: 'clase', color: '#50A579', text: t('calendar.class') }]);
      }
    };
    
    fetchTiposFecha();
  }, [t]);

  const handleDownload = async () => {
    try {
      setLoading(true);
      const response = await getCalendar()

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Calendario_Curso_20262027.pdf');
      document.body.appendChild(link);
      link.click();

      saveUserAction({ id_accion: 6, detalles_accion: `Descarga del calendario exitosa` });

      link.remove();
      setLoading(false);
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 5000);

    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      setLoading(false);
      saveUserAction({ id_accion: 6, detalles_accion: `Error al descargar el calendario` });
    }
  };

  return (
    loading ?
      (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress sx={{
          color: 'rgba(80, 165, 121, 0.7)',
        }} />
      </Box>) :

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
      }}>
        <Header setIsAuthenticated={setIsAuthenticated} />

        <Box sx={{ p: 3, maxWidth: '100%' }}>
          <Typography variant="h4" sx={{ mb: 4, color: 'black', textAlign: 'center' }}>
            <strong>{t("menuItems.calendar")}</strong>
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <ActualYearCalendar 
                userId={user.idpersona} 
                onUpdateActiveTipos={(tiposList) => setActiveTiposFecha(tiposList)} 
              />
            </Grid>
            <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center' }}>
              <STPButton
                variant="contained"
                color="primary"
                sx={{
                  mt: 2,
                  width: '70%',
                  bottom: '20px'
                }}
                onClick={handleDownload}
              >
                {t('calendar.downloadCalendar')}
              </STPButton>
            </Grid>
          </Grid>
        </Box>
      </Box>
  );
}